import { Component, OnInit, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, HostListener } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { NumberBinaryQualifierService } from 'src/app/model/api-services/qualifiers/number-binary-qualifier.service';
import { NumberHexQualifierService } from 'src/app/model/api-services/qualifiers/number-hex-qualifier.service';
import { NumberOctalQualifierService } from 'src/app/model/api-services/qualifiers/number-octal-qualifier.service';
import { InputMode } from '../number-binary-input/number-binary-input.component';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { SL_ID_PREFIX, SlIdContext } from 'src/app/model/directives/sl-id-context';

@Component({
  selector: 'app-number-hex-input',
  templateUrl: './number-hex-input.component.html',
  styleUrls: ['./number-hex-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    SlIdContext,
    {
      provide: SL_ID_PREFIX,
      useValue: 'attr-hex-input'
    }
  ],
})
export class NumberHexInputComponent extends InputComponent implements OnInit {
  public inputMode: InputMode = 'DEC';
  public valueString = '';
  public numericValue = 0;
  public menuOpen = false;
  constructor(private domNode: ElementRef, protected cdr: ChangeDetectorRef) {
    super(cdr);
    super._domNode = this.domNode;
  }

  public set currentValue(val: any) {
    super.currentValue = val;
    // this.UpdateFromValue();
  }
  public get currentValue(): any {
    return super.currentValue;
  }
  public SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
    super.SetAttribute(layer, attribute);
    let mode: InputMode = 'DEC';
    switch (this.attribute.casting.entry.type) {
      case 'number-hex':
        mode = 'HEX';
        break;
    }
    this.SetMode(mode);

  }
  @HostListener('document:click', ['$event'])
  public HandleDocumentClick(event: MouseEvent) {
    if (!this.domNode.nativeElement.contains(event.target as Node)) {
      this.menuOpen = false;
      this.cdr.detectChanges();
    }
  }
  UpdateFromValue() {
    if (['string', 'text'].indexOf(this.attribute.type) > -1) {
      this.valueString = this.currentValue;
      this.numericValue = NumberHexQualifierService.FromString(this.valueString, this.attribute.casting.entry.format);
    } else {
      this.numericValue = this.currentValue;
      this.valueString = NumberHexQualifierService.ToString(this.numericValue, this.attribute.casting.entry.format);
    }
  }
  SetMode(inputMode: InputMode) {
    this.menuOpen = false;
    if (this.valueString !== '') {
      this.numericValue = this.GetNumeric(this.inputMode);
    }
    this.inputMode = inputMode;
    if (this.valueString !== '') {
      this.UpdateValueString(this.inputMode);
      this.UpdateFromNumeric();
    }

  }
  ToggleMenu(event: Event) {
    event.stopPropagation();
    this.menuOpen = !this.menuOpen;
    this.cdr.detectChanges();
  }
  UpdateValueString(mode: InputMode) {
    switch (mode) {
      case 'DEC':
        this.valueString = '' + this.numericValue;
        break;
      case 'BIN':
        this.valueString = NumberBinaryQualifierService.ToString(this.numericValue, 'binary');
        break;
      case 'HEX':
        this.valueString = NumberHexQualifierService.ToString(this.numericValue, 'hex').toUpperCase();
        break;
      case 'OCT':
        this.valueString = NumberOctalQualifierService.ToString(this.numericValue, 'octal');
        break;

    }
  }
  UpdateFromNumeric() {
    if (['string', 'text'].indexOf(this.attribute.type) > -1) {
      this.currentValue = NumberHexQualifierService.ToString(this.numericValue, this.attribute.casting.entry.format);
    } else {
      this.currentValue = this.numericValue;
    }
  }
  GetNumeric(mode: InputMode) {
    switch (mode) {
      case 'DEC':
        const decDigits = this.valueString.match(/[0123456789]/g);
        if (decDigits !== null) {
          this.valueString = decDigits.join('');
        } else {
          this.valueString = '';
        }
        return Number(this.valueString);
      case 'BIN':
        return NumberBinaryQualifierService.FromString(this.valueString, 'binary');
      case 'HEX':
        return NumberHexQualifierService.FromString(this.valueString, 'hex');
      case 'OCT':
        return NumberOctalQualifierService.FromString(this.valueString, 'octal');
    }
  }
  InputChanged() {
    const numeric: number = this.GetNumeric(this.inputMode);
    if (this.numericValue === numeric) {
      return;
    }

    if (this.inputMode === 'HEX') {
      this.valueString = this.valueString.toUpperCase();
    }

    if (['text', 'string'].indexOf(this.attribute.type) > -1) {
      this.currentValue = NumberHexQualifierService.ToString(numeric, this.attribute.casting.entry.format);
    } else {
      this.currentValue = numeric;
    }
    this.numericValue = numeric;
  }


}
